import { InsightCard } from '../../components/dashboard/InsightCard';
import { EmptyState } from '../../components/ui/EmptyState';
import { PageHeader } from '../../components/ui/PageHeader';
import { SectionHeader } from '../../components/ui/SectionHeader';
import { insights } from '../../mock/bodyData';
import './InsightsPage.css';

const categories = ['Recovery', 'Performance', 'Body', 'Training', 'Cycle'];

export function InsightsPage() {
  return (
    <div className="page-stack">
      <PageHeader eyebrow="INSIGHTS" title="Insights" subtitle="Analysis-ready space without fake AI functionality." />

      <section>
        <SectionHeader title="Categories" />
        <div className="insight-category-grid">
          {categories.map((category) => (
            <button key={category} type="button">
              {category}
            </button>
          ))}
        </div>
      </section>

      <section>
        <SectionHeader title="Current Insights" />
        <div className="insight-list">
          {insights.map((insight) => (
            <InsightCard key={insight.id} insight={insight} />
          ))}
        </div>
      </section>

      <EmptyState title="AI coach is not part of V0.1" description="Insights are modeled now so real analysis can be added later without changing the UI contract." />
    </div>
  );
}
